var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.office && _vm.office.id)?_c('span',{staticClass:"btn",staticStyle:{"text-decoration":"underline","color":"#1976d2 !important","cursor":"pointer"},on:{"click":function($event){return _vm.gotoOfficeData(_vm.office)}}},[_vm._v("\n  "+_vm._s(_vm.linkText || _vm.office.title)+"\n\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }